/*
 * @Description: home状态管理
 * @Author: 安知鱼
 * @Email: 2268025923@qq.com
 * @Date: 2021-08-30 10:27:31
 * @LastEditTime: 2022-03-06 17:54:15
 * @LastEditors: 安知鱼
 */
import { Module } from 'vuex'
import { ElMessage } from 'element-plus'
import anRequest from '@/service/index'
import { IProductState } from './type'
import { IRootStore } from '../type'

const productModule: Module<IProductState, IRootStore> = {
  namespaced: true,
  state() {
    return {
      userContact: {},
      contactInfo: {}
    }
  },
  mutations: {
    changeContactInfo(state, contactInfo: any) {
      state.contactInfo = contactInfo
    }
  },
  actions: {
    async getContactInfo({ commit }) {
      const result = await anRequest.get({
        url: '/websiteContact'
      })
      if (result.code === '200' && result.data?.list?.length > 0) {
        commit('changeContactInfo', result.data.list[0])
      }
    },
    async submitUserContact(_, payload: any) {
      const result = await anRequest.post({
        url: '/websiteContact',
        data: payload
      })
      if (result.code === '200') {
        ElMessage.success({
          message: '提交成功！我们会尽快与您联系。',
          type: 'success'
        })
      } else {
        ElMessage.error({ message: '提交失败！', type: 'error' })
      }
    }
  }
}

export default productModule
